import type {CSSProperties} from 'react';

/** Fixed brand tokens shared across the enroll flow. Primary is per-group; the rest are constant. */
export const ENROLL_ACCENT = '#f5841f';
export const ENROLL_ACCENT_HOVER = '#d96f10';
export const ENROLL_INK = '#19203f';

/**
 * The enroll theme CSS variables. Set on the layout root, but Radix portals (dialogs, tooltips)
 * mount outside that subtree, so portaled content must re-declare these on its own root to inherit
 * the brand — custom properties cascade by DOM ancestry, not portal origin.
 */
export function enrollBrandVars(primaryColor: string): CSSProperties {
  return {
    '--enroll-primary': primaryColor,
    '--enroll-accent': ENROLL_ACCENT,
    '--enroll-accent-hover': ENROLL_ACCENT_HOVER,
    '--enroll-ink': ENROLL_INK,
  } as CSSProperties;
}
